var _radialGradient, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpinner = function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200"
  }, props), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "spinner_svg__a",
    cx: 0.66,
    cy: 0.313,
    fx: 0.66,
    fy: 0.313,
    gradientTransform: "scale(1.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0396F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#0396F9",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0396F9",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0396F9",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0396F9",
    stopOpacity: 0
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 70,
    fill: "none",
    stroke: "url(#spinner_svg__a)",
    strokeDasharray: "200 1000",
    strokeLinecap: "round",
    strokeWidth: 15,
    "transform-origin": "center"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    dur: 2,
    keySplines: "0 0 1 1",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "rotate",
    values: "360;0"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 70,
    fill: "none",
    stroke: "#0396F9",
    strokeLinecap: "round",
    strokeWidth: 15,
    opacity: 0.2,
    "transform-origin": "center"
  })));
};
export { SvgSpinner as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMDAgMjAwIj48cmFkaWFsR3JhZGllbnQgaWQ9ImExMiIgY3g9Ii42NiIgZng9Ii42NiIgY3k9Ii4zMTI1IiBmeT0iLjMxMjUiIGdyYWRpZW50VHJhbnNmb3JtPSJzY2FsZSgxLjUpIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiMwMzk2RjkiPjwvc3RvcD48c3RvcCBvZmZzZXQ9Ii4zIiBzdG9wLWNvbG9yPSIjMDM5NkY5IiBzdG9wLW9wYWNpdHk9Ii45Ij48L3N0b3A+PHN0b3Agb2Zmc2V0PSIuNiIgc3RvcC1jb2xvcj0iIzAzOTZGOSIgc3RvcC1vcGFjaXR5PSIuNiI+PC9zdG9wPjxzdG9wIG9mZnNldD0iLjgiIHN0b3AtY29sb3I9IiMwMzk2RjkiIHN0b3Atb3BhY2l0eT0iLjMiPjwvc3RvcD48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMwMzk2RjkiIHN0b3Atb3BhY2l0eT0iMCI+PC9zdG9wPjwvcmFkaWFsR3JhZGllbnQ+PGNpcmNsZSB0cmFuc2Zvcm0tb3JpZ2luPSJjZW50ZXIiIGZpbGw9Im5vbmUiIHN0cm9rZT0idXJsKCNhMTIpIiBzdHJva2Utd2lkdGg9IjE1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1kYXNoYXJyYXk9IjIwMCAxMDAwIiBzdHJva2UtZGFzaG9mZnNldD0iMCIgY3g9IjEwMCIgY3k9IjEwMCIgcj0iNzAiPjxhbmltYXRlVHJhbnNmb3JtIHR5cGU9InJvdGF0ZSIgYXR0cmlidXRlTmFtZT0idHJhbnNmb3JtIiBjYWxjTW9kZT0ic3BsaW5lIiBkdXI9IjIiIHZhbHVlcz0iMzYwOzAiIGtleVRpbWVzPSIwOzEiIGtleVNwbGluZXM9IjAgMCAxIDEiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIj48L2FuaW1hdGVUcmFuc2Zvcm0+PC9jaXJjbGU+PGNpcmNsZSB0cmFuc2Zvcm0tb3JpZ2luPSJjZW50ZXIiIGZpbGw9Im5vbmUiIG9wYWNpdHk9Ii4yIiBzdHJva2U9IiMwMzk2RjkiIHN0cm9rZS13aWR0aD0iMTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgY3g9IjEwMCIgY3k9IjEwMCIgcj0iNzAiPjwvY2lyY2xlPjwvc3ZnPg==";